export const environment = {
  production: true,
  apiUrl: 'https://panel-api.ibercon.org',
  appVersion: '2.1.0',

  disableUsers: false,
};
